var _excluded = ["rel", "href", "aria-describedby"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import React from "react";
import { Focusable, useDescriptionNode } from "@xo-union/ui-accessibility";
import PropTypes from "prop-types";
export var hasDomainPattern = /^\/\/|^https?:\/\//;
export var isSecureInteralURLPattern = /^https:\/\/(:?[^/]+\.)?theknot\.com(:?$|\/)/;
// Trust internal TK url, secure protocol paths OR relative paths
var allowReferrer = function allowReferrer(url) {
  return isSecureInteralURLPattern.test(url) || !hasDomainPattern.test(url);
};
var Link = function Link(props) {
  return /*#__PURE__*/React.createElement(Focusable, _extends({
    as: "a"
  }, props));
};

/* eslint-disable jsx-a11y/anchor-has-content */
var descriptionID = 'Union__component-standard-elements__NewWindowAnchor-description';
var NewWindowAnchor = function NewWindowAnchor(_ref) {
  var _context;
  var rel = _ref.rel,
    href = _ref.href,
    ariaDescribedBy = _ref['aria-describedby'],
    props = _objectWithoutProperties(_ref, _excluded);
  var baseRel = allowReferrer(href) ? 'noopener' : 'noopener noreferrer';
  var relValue = rel ? "".concat(baseRel, " ").concat(rel) : baseRel;
  useDescriptionNode(descriptionID, 'Opens in new window');
  var describedBy = _trimInstanceProperty(_context = "".concat(descriptionID, " ").concat(ariaDescribedBy || '')).call(_context);
  return /*#__PURE__*/React.createElement(Link, _extends({
    target: "_blank",
    rel: relValue,
    href: href
  }, props, {
    "aria-describedby": describedBy
  }));
};
process.env.NODE_ENV !== "production" ? NewWindowAnchor.propTypes = {
  href: PropTypes.string,
  rel: PropTypes.string,
  'aria-describedby': PropTypes.string
} : void 0;
var AssumedTargetAnchor = function AssumedTargetAnchor(props) {
  var href = props.href;
  if (hasDomainPattern.test(href)) {
    return /*#__PURE__*/React.createElement(NewWindowAnchor, _extends({
      href: props.href
    }, props));
  }
  return /*#__PURE__*/React.createElement(Link, props);
};
process.env.NODE_ENV !== "production" ? AssumedTargetAnchor.propTypes = {
  href: PropTypes.string,
  as: PropTypes.elementType
} : void 0;
AssumedTargetAnchor.defaultProps = {
  as: 'a'
};
export { AssumedTargetAnchor, NewWindowAnchor };